<script setup lang="ts">
withDefaults(
  defineProps<{
    vertical?: boolean;
    dense?: boolean;
  }>(),
  {
    vertical: false,
    dense: false,
  },
);
</script>

<template>
  <ul
    class="tw-grid tw-grid-cols-1"
    :class="{
      'tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 2xl:tw-grid-cols-6':
        !vertical,
      'tw-gap-2': dense,
    }"
  >
    <slot></slot>
  </ul>
</template>

<style scoped></style>
